<template>
  <v-container fluid class="note-icon-outer-container py-0 w-100 v-card">
    <v-row class="notifications-header">
      <v-col class="mb-0"> Notifications </v-col>
    </v-row>
    <v-row class="py-3 mt-0" style="background-color: var(--secondary-background);">
      <v-col class="px-0 py-0 note-icon-container">
        <v-list
          v-if="notifications && notifications.length"
          class="pt-0 pb-0 d-flex flex-column justify-center"
        >
          <notification-items-dropdown
            v-for="(notification, key) in notifications"
            :key="key"
            :notification="notification"
            @refresh="getNotifications"
          />
        </v-list>
        <span class="no-new-notifications" v-else>
          No new notifications. You're all caught up!
        </span>
      </v-col>
    </v-row>
    <v-row class="notifications-footer">
        <a class="pt-3 pb-4 w-100 see-all-notifications" href="/agents/notifications"
          >See all Notifications</a
        >
    </v-row>
  </v-container>
</template>
<script>
import NotificationItemsDropdown from "./NotificationItemsDropdown";

export default {
  name: "NotificationsDropdownMenu",
  components: {
    NotificationItemsDropdown,
  },
  data() {
    return {
      notifications: [],
      totalNotifications: 0,
      dropdownNotification: true,
      limit: 5,
      loading: false,
    };
  },
  methods: {
    async getNotifications() {
      this.loading = true;
      try {
        const params = {
          dropdownNotification: this.dropdownNotification,
          limit: this.limit,
        };

        let response = await this.$http.get(
          "/api/v1/notificationMessages/getNotifications",
          { params }
        );
        this.notifications = response.data.notifications;

        this.loading = false;
      } catch (error) {
        console.error("Error fetching notifications: ", error);
        this.loading = false;
      }
    },
  },
  mounted() {
    this.getNotifications();
  },
};
</script>
<style scoped>
.notifications-header {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: var(--secondary-background);
  padding: 5px 0px;
  font-size: 1.3rem;
}
.note-icon-outer-container {
  margin-top: 0px;
  box-shadow: none !important;
}
.note-icon-container .theme--light.v-list {
  background: transparent !important;
}
.notifications-footer {
  background-color: var(--secondary-background);
  padding-top: 0;
  padding-left: 12px;
  border-top: thin solid var(--secondary-border-color);
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
a.see-all-notifications {
  position: relative;
  display: inline-block;
  transition: color 100ms ease-in-out;
  text-decoration: none;
  color: var(--secondary-text);
  font-weight: 600;
}
a.see-all-notifications:hover {
  color: var(--primary-text);
}

.no-new-notifications {
  display: flex;
  padding-left: 12px;
  padding-top: 0px;
  padding-bottom: 0px;
}

@media screen and (max-width: 900px) {
  .no-new-notifications {
    padding-right: 25px;
  }
}
</style>
